import { render, staticRenderFns } from "./CraftOrderCreateCard.vue?vue&type=template&id=bb0702d4&scoped=true&"
import script from "./CraftOrderCreateCard.vue?vue&type=script&lang=ts&"
export * from "./CraftOrderCreateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0702d4",
  null
  
)

export default component.exports